import { Injectable } from '@nestjs/common';
import * as fs from 'fs';
import * as xlsx from 'xlsx'; // npm install xlsx
import { Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { CommonResponse, StockItemCategoryColumns, StockItemCategoryModelDto, StockItemCategoryResponseModel, TypeEnum } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { StockItemLogEntity } from './stock-item-category-log.entity';
import { StockItemEntity } from './stock-item-category.entity';


@Injectable()
export class StockItemCategoryService {
  constructor(
    @InjectRepository(StockItemEntity)
    private stockItemCategoryRepository: Repository<StockItemEntity>
  ) {}

  async StockItemuploadExcel(formData: any): Promise<StockItemCategoryResponseModel> {
    console.log(formData, 'oooooooser');
    const transactionManager = new GenericTransactionManager();
    try {
      await transactionManager.startTransaction();
      const flag = new Set<boolean>();
      const columnArray = [];
      const updatedArray = formData.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const newKey = key
            .replace(/\s/g, '')
            .replace(/[\(\)\.]/g, '')
            .replace(/-/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      });
      const difference = columnArray.filter(
        (element) => !StockItemCategoryColumns.includes(element)
      );
      console.log(difference, '----');
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new StockItemCategoryResponseModel(
          false,
          1110,
          "Excel columns doesn't match. Please attach the correct file."
        );
      }
      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === '') {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      // const deleteData = await transactionManager.getRepository(StockItemEntity).delete({})
      // if (deleteData) {
      //     flag.add(true)
      // } else {
      //     flag.add(false)
      //     return new StockItemCategoryResponseModel(false, 0, 'Something wwent wrong in data deletion')
      // }
      for (const data of convertedData) {
        // let dtoData
        if (data.Category != null) {
          const existedData = await this.stockItemCategoryRepository.findOne({
            where: {
             
              category: data.Category,
             type:data.Type
            },
          });
          if (existedData) {
            const update = await transactionManager
              .getRepository(StockItemEntity)
              .update({ id: existedData.id }, { category: data.Category });
            if (!update.affected) {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new CommonResponse(
                false,
                0,
                'Something went wrong in updating existing record'
              );
            } else {
              const logs = new StockItemLogEntity();
              
              logs.category = existedData.category;
              logs.type = existedData.type
              logs.stockItemCategoryId = existedData.id;
              const addupdatedData = await transactionManager
                .getRepository(StockItemLogEntity)
                .save(logs);
              if (addupdatedData) {
                flag.add(true);
              } else {
                flag.add(false);
                await transactionManager.releaseTransaction();
                break;
              }
            }
          } else {
            const addObj = new StockItemEntity();
           
            addObj.category = data.Category;
            addObj.type=data.Type
            const addSave = await transactionManager
              .getRepository(StockItemEntity)
              .save(addObj);
            if (addSave) {
              flag.add(true);
            } else {
              flag.add(false);
              await transactionManager.releaseTransaction();
              return new StockItemCategoryResponseModel(false, 0, 'Somthing went wrong in saving the data');
            }
          }
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new StockItemCategoryResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new StockItemCategoryResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new StockItemCategoryResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getStockItem(): Promise<StockItemCategoryResponseModel> {
    try {
        let res = []
      const info = await this.stockItemCategoryRepository.find();
      if (info.length>0) {
        for (const data of info){
            res.push(new StockItemCategoryModelDto(data.id,data.category,data.type ))
        }
        return new StockItemCategoryResponseModel(true, 1, 'Data retrieved', info);
      } else {
        return new StockItemCategoryResponseModel(false, 0, 'No data found');
      }
    } catch (err) {
      return new StockItemCategoryResponseModel(false, 0, 'Something went wrong', err);
    }
  }

  async getVendorCategories(): Promise<StockItemCategoryResponseModel> {
    try {
      const vendorCategories = await this.stockItemCategoryRepository.find({
        where: {
          type: TypeEnum.Vendor
        }
      });
  
      if (vendorCategories.length > 0) {
        const res = vendorCategories.map(data =>
          new StockItemCategoryModelDto(data.id, data.category, data.type)
        );
        return new StockItemCategoryResponseModel(true, vendorCategories.length, 'Vendor categories retrieved', res);
      } else {
        return new StockItemCategoryResponseModel(false, 0, 'No vendor categories found');
      }
    } catch (err) {
      return new StockItemCategoryResponseModel(false, 0, 'Something went wrong', err);
    }
  }


  async getEndCustomerCategories(): Promise<StockItemCategoryResponseModel> {
    try {
      const EndCustomer = await this.stockItemCategoryRepository.find({
        where: {
          type: TypeEnum.End_Customer
        }
      });
  
      if (EndCustomer.length > 0) {
        const res = EndCustomer.map(data =>
          new StockItemCategoryModelDto(data.id, data.category, data.type)
        );
        return new StockItemCategoryResponseModel(true, EndCustomer.length, 'End_Customer retrieved', res);
      } else {
        return new StockItemCategoryResponseModel(false, 0, 'No End_Customer found');
      }
    } catch (err) {
      return new StockItemCategoryResponseModel(false, 0, 'Something went wrong', err);
    }
  }


  async getStockItemCategories(): Promise<StockItemCategoryResponseModel> {
    try {
      const StockItem = await this.stockItemCategoryRepository.find({
        where: {
          type: TypeEnum.Stock_Items
        }
      });
  
      if (StockItem.length > 0) {
        const res = StockItem.map(data =>
          new StockItemCategoryModelDto(data.id, data.category, data.type)
        );
        return new StockItemCategoryResponseModel(true, StockItem.length, 'Stock Item retrieved', res);
      } else {
        return new StockItemCategoryResponseModel(false, 0, 'No Stock Item found');
      }
    } catch (err) {
      return new StockItemCategoryResponseModel(false, 0, 'Something went wrong', err);
    }
  }
  
}
